import React from 'react';

import './FooterOverlay.scss';

function FooterOverlay() {
  return (
    <div className="app__footerOverlay">
      <div className="app__footerOverlay-black" />
      <div className="app__footerOverlay-img bienvenida__bg" />
    </div>
  );
}

export default FooterOverlay;
